import React from 'react';
import IMAGES from '../../img';

const ArrowDownIcon = ({ ...props }) => (
  <img src={IMAGES.arrow_down} alt="Arrow Down" {...props} />
);

export default ArrowDownIcon;
